export interface Theme {
  fontFamily: ThemeFontFamily;
  colors: {
    inherit: 'inherit';
    current: 'currentColor';
    transparent: string;
  } & ThemeColors;
}

export type ThemeFontFamily = {
  [key: string]: string[];
};

export type ThemeColorType =
  | 'black'
  | 'white'
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'gray'
  | 'error'
  | 'warning'
  | 'success'
  | 'info'
  | 'link';

export type ThemeColorPalette = {
  50?: string;
  100?: string;
  200?: string;
  300?: string;
  400?: string;
  500?: string;
  600?: string;
  700?: string;
  800?: string;
  900?: string;
  t?: {
    50?: string;
    100?: string;
    200?: string;
    300?: string;
    400?: string;
    500?: string;
    600?: string;
    700?: string;
    800?: string;
    900?: string;
  };
};

export type ThemeColors = {
  [key in ThemeColorType]: ThemeColorPalette;
};
